import React from 'react';
import { GraduationCapIcon } from 'lucide-react';
import { careerHistory, education } from '../data/profile';
import { PageHeader } from '../components/PageHeader';
export function Career() {
  return <section className="bg-parchment py-16 lg:py-24" data-id="element-105" data-mp="2l6tc6ab4ie8j">
      <div className="mx-auto max-w-dossier px-6 lg:px-10" data-id="element-106" data-mp="2l9pc246j7czm">
        <PageHeader overline="Career History" title="Executive career trajectory" description="Nearly four decades of progressive people leadership across technology, semiconductor, pharmaceutical, and healthcare enterprises." data-id="element-107" data-mp="2g9jniwvk66lr" />

        <ol className="mt-14 space-y-12" data-id="element-108" data-mp="34677avkl9v0m">
          {careerHistory.map((role, index) => <li key={role.title} className="grid gap-3 sm:grid-cols-12 sm:gap-8" data-id="element-109" data-mp="2z7m88zh2phdr" data-mpi={index}>
              <div className="sm:col-span-3" data-id="element-110" data-mp="2z5jj0hnqvsa3">
                <p className="font-sans text-sm font-medium text-emerald" data-id="element-111" data-mp="ifcet9bfmm9">{role.period}</p>
                {index === 0 && <p className="mt-1 font-sans text-[11px] uppercase tracking-overline text-navy-400" data-id="element-112" data-mp="3ruqhxhr42jvv">
                    Current
                  </p>}
              </div>
              <div className="sm:col-span-9" data-id="element-113" data-mp="124kd537nz0ap">
                <h2 className="font-display text-2xl leading-snug text-navy" data-id="element-114" data-mp="odxd97q634d1">{role.title}</h2>
                <p className="mt-2 font-sans text-sm text-navy-600" data-id="element-115" data-mp="sf94fhoovxnc">{role.organization}</p>
                {role.note && <p className="mt-4 max-w-xl font-sans text-[15px] leading-relaxed text-navy-400" data-id="element-116" data-mp="ef85i7rzj0ai">
                    {role.note}
                  </p>}
              </div>
            </li>)}
        </ol>

        <div className="mt-20 bg-parchment-light p-9 lg:p-10" data-id="element-117" data-mp="5ge0pu4i33lv">
          <span className="inline-flex items-center gap-3" data-id="element-118" data-mp="9fvav0uvgoxd">
            <GraduationCapIcon className="h-5 w-5 text-emerald" aria-hidden="true" data-id="element-119" data-mp="9i7zfwv4xxje" />
            <span className="font-sans text-[11px] font-semibold uppercase tracking-overline text-emerald" data-id="element-120" data-mp="1ztly9tjv1tb7">
              Education
            </span>
          </span>
          <h2 className="mt-6 font-display text-3xl text-navy" data-id="element-121" data-mp="3csfgkdmhf4dl">{education.institution}</h2>
          <p className="mt-4 max-w-xl font-sans text-[17px] leading-relaxed text-navy-600" data-id="element-122" data-mp="37s04dpdxs2x7">
            {education.degrees}
          </p>
        </div>
      </div>
    </section>;
}